import { defineComponent as _defineComponent } from 'vue'
import _ from 'lodash'
import { computed, getCurrentInstance } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import { IMenuItem } from '@/view_helper/mainMenu'
import { E_MenuItem } from '@/view_helper/menu'
import { Back } from '../index'

interface IBreadcrumbItem {
    title: string
    router?: string
}

interface IRouteMeta {
    parentName?: string
    title?: any
    breadcrumbTitle?: any
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Breadcrumb',
  props: {
    menus: null
  },
  setup(__props: any) {

const props = __props as {
    menus: IMenuItem[]
}


const router = useRouter()
const route = useRoute()
const instance = getCurrentInstance()

function resolveTitle(title: any): string {
    if (_.has(E_MenuItem, title)) {
        return instance.proxy.$enumTrans.MenuItem(title as E_MenuItem) as string
    }
    return String(title ?? '')
}

function findPath(menus: IMenuItem[], routeName: string): IMenuItem[] | null {
    for (const menu of menus) {
        if (menu.router === routeName) {
            return [menu]
        }
        if (!_.isEmpty(menu.children)) {
            const childPath = findPath(menu.children, routeName)
            if (childPath) {
                return [menu, ...childPath]
            }
        }
    }
    return null
}

function getRouteMeta(routeName: string): IRouteMeta {
    try {
        const resolvedRoute = router.resolve({ name: routeName }).route
        const matched = resolvedRoute.matched || []
        const lastMatchedRoute = _.last(matched)
        return (lastMatchedRoute?.meta || resolvedRoute.meta || {}) as IRouteMeta
    } catch (err) {
        return {}
    }
}

function getFallbackBreadcrumb(routeName: string): IBreadcrumbItem | null {
    const meta = getRouteMeta(routeName)
    const title = meta.breadcrumbTitle ?? meta.title
    if (!title) return null
    return {
        title: resolveTitle(title),
        router: routeName,
    }
}

function resolveBreadcrumbPath(routeName: string, visitedRouteNames = new Set<string>()): IBreadcrumbItem[] | null {
    if (visitedRouteNames.has(routeName)) return null
    visitedRouteNames.add(routeName)

    const menuPath = findPath(props.menus, routeName)
    if (menuPath) {
        return menuPath.map(item => ({
            title: resolveTitle(item.title),
            router: item.router,
        }))
    }

    const parentName = getRouteMeta(routeName).parentName
    if (!parentName || parentName === routeName) return null

    const parentPath = resolveBreadcrumbPath(parentName, visitedRouteNames)
    if (!parentPath) return null

    const currentBreadcrumb = getFallbackBreadcrumb(routeName)
    return currentBreadcrumb ? [...parentPath, currentBreadcrumb] : parentPath
}

const breadcrumbs = computed(() => {
    const name = route.name
    if (!name) return []
    return resolveBreadcrumbPath(name) || []
})

function onBack() {
    router.back()
}


return { __sfc: true,props, router, route, instance, resolveTitle, findPath, getRouteMeta, getFallbackBreadcrumb, resolveBreadcrumbPath, breadcrumbs, onBack, Back }
}

})